import React, { useEffect, useState, useRef } from "react";
import Header from "../../layouts/Header";
import { ToastContainer, toast } from "react-toastify";
import { axios_instance } from "../../api/axios_instance";
import {
  decryptRequest,
  encryptRequest,
} from "../../utils/encryptdecryptrequest";
import LoadingModal from "../../layouts/LoadingModal";

const ResourcePanel = () => {
  const initialState = { showNavigationModal: false };

  const [ResourcePanelState, setResourcePanelState] = useState(initialState);
  const [banks, setBanks] = useState([]);
  const fileInputRefs = useRef([]);
  const [showLoadingModal, setShowLoadingModal] = useState(false);

  const fetchBanks = async () => {
    try {
      let response = await axios_instance({
        url: "/resource/getAllResourceBank",
        method: "GET",
      });
      if (response.status === 200) {
        response = decryptRequest(response.data.resData);
        setBanks([...response.result]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchBanks();
  }, []);

  const handleFileChange = async (e, idx) => {
    toast.dismiss();
    setShowLoadingModal(true);
    try {
      const file = e.target.files[0];
      if (!file) {
        toast.error("No file selected. Please choose a file to upload.");
        return;
      }

      const fileType = file.name.split(".").pop().toLowerCase();
      const validTypes = ["xlsx", "csv"];

      if (!validTypes.includes(fileType)) {
        toast.error("Invalid file type. Only .xlsx or .csv files are allowed.");
        return;
      }

      const data = new FormData();
      data.append("bank", JSON.stringify(banks[idx]));
      data.append("file", file);

      const response = await axios_instance({
        url: "/resource/uploadResourceBankFile",
        method: "POST",
        data,
        headers: { "Content-Type": "multipart/form-data" },
      });

      const { status, message } = decryptRequest(response.data);

      if (status === true) {
        toast.success(message);
      } else {
        toast.error(message);
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        toast.error(error.response.data.message);
      }
    } finally {
      setShowLoadingModal(false);
      if (fileInputRefs.current[idx]) {
        fileInputRefs.current[idx].value = null;
      }
    }
  };

  const downloadResourceFile = async (idx) => {
    toast.dismiss();
    setShowLoadingModal(true);
    try {
      let reqData = encryptRequest({ bank: JSON.stringify(banks[idx]) });
      let result = await axios_instance({
        url: "/resource/downloadResourceBankFile",
        method: "POST",
        data: { reqData },
      });
      let response = decryptRequest(result.data.resData);
      if (response.status === true) {
        window.open(response.downloadUrl);
        toast.success(response.message);
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        toast.error(error.response.data.message);
      }
    } finally {
      setShowLoadingModal(false);
    }
  };

  const handleButtonClick = (index) => {
    if (fileInputRefs.current[index]) {
      fileInputRefs.current[index].click();
    }
  };

  return (
    <span>
      {showLoadingModal && <LoadingModal />}
      <Header
        isNavigationModal={ResourcePanelState.showNavigationModal}
        closeNavigationModal={() =>
          setResourcePanelState({
            ...ResourcePanelState,
            showNavigationModal: false,
          })
        }
        openNavigationModal={() =>
          setResourcePanelState({
            ...ResourcePanelState,
            showNavigationModal: true,
          })
        }
      ></Header>
      <div className="container-fluid">
        <ToastContainer
          closeOnClick={false}
          draggable={false}
          closeButton={false}
        />
        <div className="row">
          <div className="main_wrapper">
            <div className="overlay" id="navigation-overly"></div>
            <section className="right_wrapper">
              <div className="panel-white">
                <div className="grayFiltr-bg brdr-FB clearfix">
                  <div className="col-md-12 ">
                    <h3 className="list_title clearfix">RESOURCES PANEL</h3>
                  </div>
                </div>

                <div className="container-fluid">
                  <div className="main_wrapper">
                    <section className="right_wrapper">
                      <div className="panel-white">
                        <div className="filter_flyout">
                          <div className="filter_box filter-section-bx resource_box">
                            <div className="clearfix resource_table">
                              <div>
                                <table className=" display table table-bordered table-hover">
                                  <thead>
                                    <tr>
                                      <th className="align_center">
                                        Bank Name
                                      </th>
                                      <th className="align_action">Action</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {banks.map(({ bank_name }, idx) => (
                                      <tr key={idx} className="align_center">
                                        <td className="text_color">
                                          {bank_name}
                                        </td>
                                        <td>
                                          <div className="resource_action">
                                            <div className="resource_upload">
                                              <input
                                                type="file"
                                                ref={(el) =>
                                                  (fileInputRefs.current[idx] =
                                                    el)
                                                }
                                                style={{ display: "none" }}
                                                accept=".xlsx, .csv"
                                                onChange={(e) =>
                                                  handleFileChange(e, idx)
                                                }
                                              />
                                              <span>
                                                <img
                                                  src={`${process.env.REACT_APP_STYLES_PATH}upload_rp.png`}
                                                  alt="icon"
                                                  onClick={() =>
                                                    handleButtonClick(idx)
                                                  }
                                                />
                                              </span>
                                            </div>
                                            <div className="resource_download">
                                              <span>
                                                <img
                                                  src={`${process.env.REACT_APP_STYLES_PATH}download_rp.png`}
                                                  alt="icon"
                                                  onClick={() =>
                                                    downloadResourceFile(idx)
                                                  }
                                                />
                                              </span>
                                            </div>
                                          </div>
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </span>
  );
};

export default ResourcePanel;
